(function () {
  if (window.__tk9PatchDisclosuresLoaded) return;
  window.__tk9PatchDisclosuresLoaded = true;

  var path = String(window.location && window.location.pathname || '').toLowerCase();
  if (!/\/products\//.test(path)) return;

  var patchHandles = [
    'custom-patch',
    'patches-bundle',
    'hook-loop-patch-for-harness',
    'usa-flag-with-paw-patch',
    'usa-flag-patch',
    'dad-says-im-special',
    'mama-says-im-special-patch',
    'do-not-pet-patch',
    'in-training-patch',
    'orange-ask-to-pet-patch',
    'k9-patch',
    'black-ask-to-pet-patch',
    'service-dog-in-training-patch',
    'service-dog-patch',
    'emotional-support-patch',
    'in-my-defense-i-was-left-unsupervised-hook-loop-patch-for-harness',
    'team-k9-hook-loop-patch-for-harness'
  ];

  var isPatchProduct = patchHandles.some(function (handle) {
    return path.indexOf('/products/' + handle) !== -1;
  });

  if (!isPatchProduct) {
    var title = document.querySelector('h1');
    isPatchProduct = !!(title && /patch/i.test(title.textContent || ''));
  }

  if (!isPatchProduct) return;

  var FRIENDLY_PATCH_NOTE = "Customize your dog's harness with a patch that fits their look, role, or everyday routine.";

  function replaceStalePatchCopy() {
    var pattern = /Our hook\s*&\s*loop patches are for harness customization and are not a certification, registration, or access pass\./i;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      if (!pattern.test(node.nodeValue || '')) continue;
      node.nodeValue = node.nodeValue.replace(pattern, FRIENDLY_PATCH_NOTE);
    }
  }

  function injectPatchNote() {
    document.querySelectorAll('[data-tk9-patch-disclaimer]').forEach(function (note) {
      note.remove();
    });
    return true;
  }

  function injectStyle() {
    if (document.getElementById('tk9-patch-disclosures-style')) return;
    var style = document.createElement('style');
    style.id = 'tk9-patch-disclosures-style';
    style.textContent = '[data-tk9-patch-disclaimer]{display:none!important}';
    document.head.appendChild(style);
  }

  function boot() {
    injectStyle();
    replaceStalePatchCopy();
    injectPatchNote();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      replaceStalePatchCopy();
      injectPatchNote();
      if (tries > 40) window.clearInterval(timer);
    }, 250);
    var observer = new MutationObserver(function () {
      replaceStalePatchCopy();
      injectPatchNote();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
      replaceStalePatchCopy();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
